module.exports = __webpack_public_path__ + "static/1-new_mobile-c3a5bb3c468f1bd2f307b5fcda466f3a.jpg";